import { isNotNil } from 'shared/src/utils/isNotNil';

type PromotionLogo = {
  url: string;
  width: number;
  height: number;
};

export const isValidPromotionLogo = (
  logo: PromotionLogo | null,
): logo is PromotionLogo =>
  isNotNil(logo) &&
  logo.url.trim().length > 0 &&
  logo.width > 0 &&
  logo.height > 0;
